<template>
	<div class="investmentServices">
		<div class="parkService__title">
			<p>融通服务</p>
			<div class="parkService__border"></div>
		</div>
		<div class="parkService__service">
			<div class="parkService__content">
				<p>
					{{
						company
					}}股东之一为广州广电研究院有限公司，园区嫁接广州无线电集团产业和资本资源，借助集团的资源优势，搭建集团下属的大企业与科技园的中小企业的沟通平台，目的在于形成大企业带动中小企业发展，中小企业为大企业注入活力的融通发展新格局。
				</p>
				<br />
				<p>
					{{
						company
					}}另一股东为广州凯云物业服务有限公司，园区嫁接广州开发区控股集团的产业优势，对接科技金融资源，助力企业发展，实现集团与科技园大中小企业融通和高质量发展。
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: {},
	data() {
		return {}
	},
	computed: {
		...mapState(['company']),
	},
	created() {},
	mounted() {},
	watch: {},
	methods: {},
	components: {},
}
</script>

<style lang="scss">
.investmentServices {
	text-align: center;
	padding-bottom: 40px;
}
</style>
